"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = _interopRequireDefault(require("react"));

require("./footer.scss");

var _reactBootstrap = require("react-bootstrap");

var _suLogoBlue2x = _interopRequireDefault(require("./images/su-logo-blue-2x.png"));

var _lilwLogoBlue = _interopRequireDefault(require("./images/lilw-logo-blue.png"));

var _erdf = _interopRequireDefault(require("./images/erdf.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterLink(_ref) {
  var path = _ref.path,
      text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "footer-links-list-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.swansea.ac.uk/".concat(path)
  }, text));
}

function Footer(_ref2) {
  var logos = _ref2.logos;
  return /*#__PURE__*/_react.default.createElement("footer", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "main"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 8
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'contact-us',
    text: 'Contact Us'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'jobs-at-swansea',
    text: 'Jobs'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'the-university/colleges',
    text: 'Colleges'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'press-office',
    text: 'Press'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'about-us/safety-and-security/health-and-safety',
    text: 'Health & Safety'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'disclaimer-and-copyright',
    text: 'Disclaimer & Copyright'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'privacyandcookies',
    text: 'Privacy & Cookies'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'media/Modern-Slavery-Statement.pdf',
    text: 'Modern Slavery Statement'
  }), /*#__PURE__*/_react.default.createElement(FooterLink, {
    path: 'the-university/accessibility/swansea-ac-uk',
    text: 'Accessibility Statement'
  })), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Swansea University is a registered charity, No. 1138342")))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "logos"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "justify-content-md-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Swansea University",
    src: _suLogoBlue2x.default
  }), /*#__PURE__*/_react.default.createElement("img", {
    alt: "Legal Innovation Lab Wales",
    src: _lilwLogoBlue.default
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: "erdf",
    alt: "European Regional Development Fund",
    src: _erdf.default
  }))), logos));
}